module.exports = "https://99designs-start-assets.imgix.net/js/9cbf89ad890875e5af1b89d680cd4799.png";